NHS.Scripts.HomePage = function (searchClass, parameters) {
    this.searchClass = searchClass;
    this._parameters = parameters;
};

NHS.Scripts.HomePage.prototype =
{
    initialize: function () {
        this.lazyLoadGeneral("nhs_HomeContentTeaser", this._parameters.GetBrandImagesUrl, "#nhs_HomeBuilders");
        this.lazyLoadGeneral("nhs_HomeContentTeaser", this._parameters.GetHomeHotUrl, "#nhs_HomeContentTeaser nav");
        this.lazyLoadGeneral("nhs_HomeBuilders", this._parameters.GetWhyBuyNewUrl, "#nhs_HomeWhyNew");
        this.lazyLoadGeneral("nhs_HomeWhyNew", this._parameters.GetHomeResourcesUrl, "#nhs_HomeResources");
        this.lazyLoadGeneral("nhs_HomeResources", this._parameters.GetEBookSectionUrl, "#nhs_EbookSection");

        // Let the Automation Tool know that the search box was setup 
        jQuery("#nhs_SearchBoxReadyFlag").val("true");

        if (window.location.search.indexOf('showlogin') !== -1) {
            setTimeout(function() {
                if (jQuery('#nhs_GlobalNavAccountV2 a').length > 0)
                    jQuery('#nhs_GlobalNavAccountV2 a')[0].click();
                
            }, 2000);                           
        }

    },

    initNhlSlideShow: function () {
        //Slideshow - NHL only
        jQuery('.fadein img:gt(0)').hide();
        setInterval(function () { jQuery('.fadein :first-child').fadeOut(1000).next('img').fadeIn(250).end().appendTo('.fadein'); }, 5000);
    },
    lazyLoadGeneral: function (VisElement, UrlParam, DestElement) {
        var self = this;
        var lazyLoadReady = false;
        var dataLoad = {
            ElementVisibleId: VisElement,
            UpdateAction: function (isVisible) {
                if (isVisible && lazyLoadReady === false) {
                    lazyLoadReady = true;
                    jQuery.ajax({
                        url: UrlParam,
                        type: "GET",
                        success: function (data) {
                            jQuery(DestElement).html(data);
                        }
                    });

                }
            }
        };
        jQuery.LazyLoad(dataLoad);

    }
}

var typeaheadInput = document.querySelector("#HeaderSearchText");

if (typeaheadInput) {
    HeaderSearchText.addEventListener("click",
        function() {
            var searchOptions = document.querySelector("#nhs_HomeSearchOptions");
            var fieldsets = searchOptions.querySelectorAll("fieldset");

            searchOptions.style.display = "block";

            for (var i = 0; i < fieldsets.length; i++) {
                var element = fieldsets[i];

                element.style.display = "block";
            }
        }
  );

    let form = document.getElementById('formNewHomePage');

    let search = new SearchFormComponent({
      form: form,
      submitButton: form.querySelector('#HomeSearchBtn'),
      searchTextField: form.querySelector('[data-component-rol="target-input"]'),
      validationError: form.querySelector("#nhs_field_validation_error"),
      shouldAlwaysSubmitForm: false,
      useBaseUrl: false,
      useAutocompleteForSubmit: true
    });
}


